// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__rwZLs","colMaxWidth":"Table_colMaxWidth__2fnaa"};